import AddFilter from "./AddFilter";
import FilteredPopulation from "./population/FilteredPopulation";

import PopulationOverview from "@/module/population/Overview";
import PatientRoutes from "@/module/patient/routes";

const OverviewRoute = {
  path: "",
  component: PopulationOverview,
  props: true,

  icon: "el-icon-odometer",
  text: "Overview",
};

export default [
  {
    path: "filter",
    component: AddFilter,
  },
  {
    path: "filter/:filter",
    component: FilteredPopulation,
    props: true,

    children: [OverviewRoute, ...PatientRoutes],
  },
];
